import * as Sentry from "@sentry/react";

let initialized = false;

const initSentry = () => {
  const dsn = process.env.REACT_APP_SENTRY_DSN || "";
  if (initialized || !dsn) return;

  Sentry.init({
    dsn,
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACE_SAMPLE_RATE || 0.1),
    environment: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || "production",
    beforeSend(event) {
      if (event.request?.headers) delete event.request.headers;
      return event;
    },
  });
  initialized = true;
};

const logError = (error, context = {}) => {
  try {
    Sentry.captureException(error, { extra: context });
  } catch (_) {
    // no-op
  }
};

const logMessage = (message, context = {}) => {
  try {
    Sentry.captureMessage(String(message || ""), { extra: context });
  } catch (_) {
    // no-op
  }
};

export { initSentry, logError, logMessage };
